import React, { createContext, useState, useEffect } from 'react'

export const AuthContext = createContext()

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)
  const [username, setUsername] = useState(null)
  const [email, setEmail] = useState(null)
  const [userId, setUserId] = useState(null)
  const [userToken, setUserToken] = useState(null)
  const [name, setName] = useState(null)
  const [profilePicture, setProfilePicture] = useState(null)
  const [phoneNum, setPhoneNum] = useState(null)
  const [isPublic, setIsPublic] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const [visibleSection, setVisibleSection] = useState('posts')
  const [signinOptions, setSetSigninOptions] = useState(null)

  const handleSwitchSection = (section) => setVisibleSection(section)

  useEffect(() => {
    const storedAuthState = localStorage.getItem('isAuthenticated') // "true"/"false" or null
    const storedUsername = localStorage.getItem('username')
    const storedEmail = localStorage.getItem('email')
    const storedUserId = localStorage.getItem('userId')
    const storedUserToken = localStorage.getItem('userToken')
    const storedName = localStorage.getItem('name')
    const storedProfilePicture = localStorage.getItem('profilePicture')
    const storedPhoneNum = localStorage.getItem('phoneNum')
    const storedIsPublic = localStorage.getItem('isPublic') // "true"/"false" or null
    const storedIsAdmin = localStorage.getItem('isAdmin') // "true"/"false" or null
    const storedSigninOptions = localStorage.getItem('v_signin_options') // JSON or null

    if (storedAuthState !== null) setIsAuthenticated(storedAuthState === 'true')
    if (storedUsername) setUsername(storedUsername)
    if (storedEmail) setEmail(storedEmail)
    if (storedUserId) setUserId(storedUserId)
    if (storedUserToken) setUserToken(storedUserToken)
    if (storedName) setName(storedName)
    if (storedProfilePicture) setProfilePicture(storedProfilePicture)
    if (storedPhoneNum) setPhoneNum(storedPhoneNum)
    if (storedIsPublic !== null) setIsPublic(storedIsPublic === 'true')
    if (storedIsAdmin !== null) setIsAdmin(storedIsAdmin === 'true')

    if (storedSigninOptions) {
      try {
        setSetSigninOptions(JSON.parse(storedSigninOptions))
      } catch {
        // if old runs saved a non-JSON string, just keep it as-is
        setSetSigninOptions(storedSigninOptions)
      }
    }

    setLoading(false)
  }, [])

  const signIn = (data) => {
    setIsAuthenticated(true)
    setUsername(data?.username ?? null)
    setEmail(data?.email ?? null)
    setUserId(data?.id ?? null)
    setUserToken(data?.token ?? null)
    setName(data?.name ?? null)
    setProfilePicture(data?.profilePicture ?? null)
    setPhoneNum(data?.phoneNum ?? null)
    setIsPublic(!!data?.isPublic)
    setIsAdmin(!!data?.isAdmin)
    setSetSigninOptions(data?.signin_options ?? null)

    localStorage.setItem('isAuthenticated', 'true')
    localStorage.setItem('username', data?.username ?? '')
    localStorage.setItem('email', data?.email ?? '')
    localStorage.setItem('userId', data?.id ?? '')
    localStorage.setItem('userToken', data?.token ?? '')
    localStorage.setItem('name', data?.name ?? '')
    localStorage.setItem('profilePicture', data?.profilePicture ?? '')
    localStorage.setItem('phoneNum', data?.phoneNum ?? '')
    localStorage.setItem('isPublic', String(!!data?.isPublic)) // "true"/"false"
    localStorage.setItem('isAdmin', String(!!data?.isAdmin)) // "true"/"false"
    localStorage.setItem(
      'v_signin_options',
      JSON.stringify(data?.signin_options ?? null)
    )
  }

  const signOut = () => {
    setIsAuthenticated(false)
    setUsername(null)
    setEmail(null)
    setUserId(null)
    setUserToken(null)
    setName(null)
    setProfilePicture(null)
    setPhoneNum(null)
    setIsPublic(false)
    setIsAdmin(false)
    setSetSigninOptions(null)

    localStorage.removeItem('isAuthenticated')
    localStorage.removeItem('username')
    localStorage.removeItem('email')
    localStorage.removeItem('userId')
    localStorage.removeItem('userToken')
    localStorage.removeItem('name')
    localStorage.removeItem('profilePicture')
    localStorage.removeItem('phoneNum')
    localStorage.removeItem('isPublic')
    localStorage.removeItem('isAdmin')
    localStorage.removeItem('v_signin_options')
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        signIn,
        signOut,
        loading,
        email,
        username,
        userId,
        userToken,
        setUsername,
        name,
        setName,
        profilePicture,
        setProfilePicture,
        phoneNum,
        isPublic,
        setPhoneNum,
        setIsPublic,
        setEmail,
        handleSwitchSection,
        visibleSection,
        isAdmin,
        signinOptions,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
